<template>
  <a-modal title="Shift Overlap!" :visible="visible" width="900px" :destroy-on-close="true" @cancel="closeModal">
    <div class="flex flex-column gap-2">
      <span>
        You can't adjust shift with entered data. It overlaps with the worked shifts. Please check shifts below and
        correct the entered shift data.
      </span>
      <div class="table_controls_and_data">
        <div></div>

        <div class="flex gap-2 flew-wrap ml-auto">
          <a-button
            class="flex align-items-center justify-content-center"
            @click="$emit('reload')"
            title="Refresh Page"
          >
            <a-icon width="20" height="20" icon="solar:refresh-square-broken" />
          </a-button>
        </div>
      </div>
      <a-table
        size="small"
        row-key="id"
        :columns="overlappedShiftsColumns"
        :data-source="overlappingShifts"
        :scroll="{ x: 1000 }"
        :loading="loading"
        :locale="{ emptyText: 'No Overlaps Founded' }"
        :customRow="
          record => ({
            on: {
              click: () => openShiftModal(record.id)
            }
          })
        "
      >
        <span slot="associate" slot-scope="text, record">
          <grouped-associate-info
            :first-name="record.internal_payment_info.associate.first_name"
            :last-name="record.internal_payment_info.associate.last_name"
            :photo-url="record.internal_payment_info.associate.photo_url"
            :role="record.internal_payment_info.associate.role.name"
            :payment-info="{
              payment_type: record.internal_payment_info.payment_type,
              method: record.internal_payment_info.pay_method,
              legal_entity: record.internal_payment_info.legal_entity
            }"
            :associate-number="record.internal_payment_info.associate.associate_number"
            :scheduled-type="record.internal_payment_info.associate.schedule_type"
          />
        </span>
        <span slot="start" slot-scope="text, record">
          {{ formatOverlappingShiftsDateTime(record.signed_start) }}
        </span>
        <span slot="end" slot-scope="text, record">
          {{ formatOverlappingShiftsDateTime(record.signed_end) }}
        </span>
        <span class="tags-cell" slot="status" slot-scope="text, record">
          <shift-status :shift="record" @handleClick="key => handleFlagClick(record, key)" />
        </span>
      </a-table>
    </div>
    <template slot="footer">
      <div class="flex justify-content-between">
        <a-button @click="closeModal">Close</a-button>

        <a-button @click="closeModal">Edit Shift Times</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import Util from '@/util'
import { Button, Table } from 'ant-design-vue'
import ShiftTableStatus from '../shift-table-status.vue'
import GroupedAssociateInfo from '@/components/ui/grouped-associate-info.vue'

export default {
  components: {
    'a-table': Table,
    'a-button': Button,
    'shift-status': ShiftTableStatus,
    'grouped-associate-info': GroupedAssociateInfo
  },
  data() {
    return {
      overlappedShiftsColumns: [
        {
          title: 'Shift #',
          width: 100,
          dataIndex: 'id'
        },
        {
          title: 'Associate',
          key: 'associate',
          width: 300,
          scopedSlots: { customRender: 'associate' },
          sorter: (a, b) => {
            const aName = Util.combineAssociateName(
              a.internal_payment_info.associate.first_name,
              a.internal_payment_info.associate.last_name
            )
            const bName = Util.combineAssociateName(
              b.internal_payment_info.associate.first_name,
              b.internal_payment_info.associate.last_name
            )

            return aName == null ? -1 : bName == null ? 1 : aName.localeCompare(bName)
          }
        },
        {
          title: 'Status',
          key: 'status',
          width: 200,
          scopedSlots: { customRender: 'status' },
          sorter: (a, b) => (a.status == null ? -1 : b.status == null ? 1 : a.status.localeCompare(b.status))
        },
        {
          title: 'Start',
          width: 200,
          scopedSlots: { customRender: 'start' }
        },
        {
          title: 'End',
          width: 200,
          scopedSlots: { customRender: 'end' }
        }
      ]
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    overlappingShifts: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatOverlappingShiftsDateTime(utcString) {
      return Util.convertDateTimeToCurrentTimeZoneFormattedString(utcString)
    },
    editExistingShift(id) {
      this.$emit('edit', id)
    },
    closeModal() {
      this.$emit('update:visible', false)
    },
    openShiftModal(openShift) {
      const href = this.$router.resolve({
        query: { ...this.$route.query, openShift }
      }).href

      const fullUrl = window.location.origin + href

      window.open(fullUrl, '_blank')
    }
  }
}
</script>

<style scoped>
.already-existing-shift-modal {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
</style>
